/** 车型厂商管理API */
import type { Api } from '@/typings/api';
import { post } from '../../request';
const prefix = '/base/vehicleOem';
/**
 * 分页查询车型厂商管理
 *
 * @param params 查询参数
 */
export const findPage: Api.CommonMethods.FindPage<Api.Base.VehicleOem> = params => {
  return post(`${prefix}/findPage`, params);
};
/**
 * 查询车型厂商管理列表
 *
 * @param params 查询参数
 */
export const findAll: Api.CommonMethods.FindAll<Api.Base.VehicleOem> = params => {
  return post(`${prefix}/findAll`, params);
};
/**
 * 查询单个车型厂商管理
 *
 * @param id 车型厂商管理ID
 * @param column 查询字段
 */
export const findOne: Api.CommonMethods.FindOne<Api.Base.VehicleOem> = (id: string, column?: string[]) => {
  return post(`${prefix}/findOne`, { id, column });
};
/**
 * 保存车型厂商管理
 *
 * @param params 车型厂商管理信息
 */
export const doSave: Api.CommonMethods.Save = params => {
  return post(`${prefix}/save`, params);
};
/**
 * 更新车型厂商管理信息
 *
 * @param params 车型厂商管理信息
 */
export const doUpdate: Api.CommonMethods.Update = params => {
  return post(`${prefix}/update`, params);
};
/**
 * 删除车型厂商管理
 *
 * @param id 车型厂商管理ID
 */
export const doDelete: Api.CommonMethods.Delete = id => {
  return post(`${prefix}/delete?id=${id}`);
};
/**
 * 批量删除车型厂商管理
 *
 * @param ids 车型厂商管理ID数组
 */
export const doBatchDelete: Api.CommonMethods.BatchDelete = ids => {
  return post(`${prefix}/deleteList`, { ids });
};

export default {
  findPage,
  findOne,
  doSave,
  doUpdate,
  doDelete,
  doBatchDelete
};
